import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Config } from '../app.config';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  public bereiche:any = null;
  public anwendungen:any = [];

  constructor(
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.load();
  }

  scroll(i) {
    window.scrollTo(0, document.getElementById('bereich-' + i).offsetTop);
  }

  filter(anwendung) {
    anwendung.checked = !anwendung.checked;
    let do_filter = false;
    for(let anwendung of this.anwendungen) {
      if(anwendung.checked) {
        do_filter = true;
        break;
      }
    }

    if(do_filter) {
      for(let bereich of this.bereiche) {
        bereich.show = false;
        for(let frage of bereich.fragen) {
          frage.show = false;        
        }
      }
  
      for(let anwendung of this.anwendungen) {
        if(anwendung.checked) {
          for(let bereich of this.bereiche) {
            for(let frage of bereich.fragen) {
              if(frage.anwendungsbereich.indexOf(anwendung.name) != -1) {
                frage.show = true;
                bereich.show = true;
              }
            }
          }
        }
      }
    }
    else {
      for(let bereich of this.bereiche) {
        bereich.show = true;
        for(let frage of bereich.fragen) {
          frage.show = true;        
        }
      }
    }
  }

  async load() {
    try {
      let bereiche:any = await this.http.get(Config.backend + '/bereiche?_format=json').toPromise();
      let fragen:any = await this.http.get(Config.backend + '/fragen?_format=json').toPromise();      
      
      let all_anwendungen = [];

      for(let frage of fragen) {
        let anwendungen = frage.anwendungsbereich.split(', ');        
        frage.filled = 0;
        frage.showDetail = false;
        frage.show = true;
        for(let anwendung of anwendungen) {          
          if(all_anwendungen.indexOf(anwendung) == -1) {
            all_anwendungen.push(anwendung);
          }
        }              
      }

      for(let anwendung of all_anwendungen) {
        this.anwendungen.push({name: anwendung, selected: false})
      }
      
      for(let bereich of bereiche) {
        bereich.fragen = [];
        bereich.show = true;
        bereich.hasDetails = false;
        for(let frage of fragen) {
          if(frage.aktivitaetsbereich == bereich.nid) {
            bereich.fragen.push(frage);
          }
        }
      }

      
      this.bereiche = bereiche;
    }
    catch(error) {
      console.log("ERROR:", error)
    }
  }

  print() {    
    window.print();
  }

  set(bereich, frage, num) {
    frage.filled = num;
    frage.showDetail = num != 1;
    bereich.hasDetails = false;
    for(let frage of bereich.fragen) {
      if(frage.filled == 2 || frage.filled == 3) {
        bereich.hasDetails = true;
        break;
      }
    }
  }
}
